export default __webpack_public_path__ + "static/media/qantas-hotels-light.4199e60a.svg";